<template>
  <div class="mod-companyaccountdetail">
    <el-form
      :model="searchForm"
      @keyup.enter.native="getDataList()"
      ref="dataForm"
      inline
      class="bysearchForm"
    >
      <div class="searchLine">
        <el-form-item class="typeInput">
          <el-input
            v-model="searchForm.name"
            placeholder="公司名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="typeInput">
          <el-select
            v-model="searchForm.auditStatus"
            placeholder="审核状态"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in auditStatusOptions"
              :key="index"
              :label="item.name"
              :value="item.auditStatus"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="充值日期" class="typeInput">
          <el-date-picker
            v-model="value"
            class="el-popper DatepickerTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="typeInput">
          <el-button @click="getDataList()">查询</el-button>
          <el-button
            v-if="isAuth('tc:companyaccountdetail:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >充值</el-button
          >
          <el-button
            v-if="isAuth('tc:companyaccountdetail:updateExamined')"
            @click="dialogAuditVisible = true"
            :disabled="dataListSelections.length <= 0"
            type="primary"
            >审核</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      title="充值审核"
      append-to-body
      :visible.sync="dialogAuditVisible"
      v-loading="loading"
    >
      <el-form :model="dataForm" ref="dataForm">
        <div class="tablePart">
          <el-form-item label="实际支付：">
            <el-input
              v-model="dataForm.realPay"
              clearable
              placeholder="审核不通过不用填此项"
              resize="none"
            />
          </el-form-item>
          <el-form-item label="审核说明：">
            <el-input v-model="dataForm.remarks" clearable resize="none" />
          </el-form-item>
        </div>
      </el-form>
      <div class="btn-wrap" slot="footer">
        <el-button @click="pass(1)" type="primary">通过</el-button>
        <el-button @click="pass(2)" type="danger">不通过</el-button>
        <el-button @click="dialogAuditVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-table
      :data="dataList"
      stripe
      border
      v-loading="dataListLoading"
      @row-click="handleRowClick($event, () => {})"
      ref="dataList"
      @select="select"
      @select-all="handleSelectAll"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column
        type="selection"
        :aria-disabled="true"
        header-align="center"
        align="center"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="companyName"
        header-align="center"
        align="center"
        label="公司"
      >
      </el-table-column>
      <el-table-column
        prop="changedTime"
        header-align="center"
        align="center"
        label="充值时间"
      >
      </el-table-column>
      <el-table-column
        prop="changedMoney"
        header-align="center"
        align="center"
        label="充值金额"
      >
        <template slot-scope="scope">
          <el-tag effect="plain" size="mini"
            >￥{{ scope.row.changedMoney }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="auditStatus"
        header-align="center"
        align="center"
        label="充值审核状态"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.auditStatus === 1" type="success" size="mini"
            >充值成功</el-tag
          >
          <el-tag
            v-else-if="scope.row.auditStatus === 2"
            type="info"
            size="mini"
            >充值失败</el-tag
          >
          <el-tag
            v-else-if="scope.row.auditStatus === 0"
            type="warning"
            size="mini"
            >待审核</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="realPay"
        header-align="center"
        align="center"
        label="实际支付"
      >
        <template slot-scope="scope">
          <el-tag type="success" effect="plain" size="mini"
            >￥{{ scope.row.realPay }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="approveName"
        header-align="center"
        align="center"
        label="审核人"
      >
      </el-table-column>
      <el-table-column
        prop="reviewTime"
        header-align="center"
        align="center"
        label="审核时间"
      >
      </el-table-column>
      <el-table-column
        prop="remarks"
        header-align="center"
        align="center"
        label="备注"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './companyaccountdetail-add-or-update';
import { listMixin, normal } from '@/mixins';

export default {
  mixins: [listMixin, normal],
  data() {
    return {
      searchForm: {
        name: '',
        startTime: '',
        endTime: '',
        auditStatus: '',
      },
      dataForm: {
        id: '',
        remarks: '',
        realPay: '',
        auditStatus: '',
      },
      dataList: [],
      auditStatusOptions: [
        {
          auditStatus: 0,
          name: '待审核',
        },
        {
          auditStatus: 1,
          name: '充值成功',
        },
        {
          auditStatus: 2,
          name: '充值失败',
        },
      ],
      value: [],
      dialogAuditVisible: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  components: {
    AddOrUpdate,
  },
  activated() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      if (this.value?.length) {
        this.searchForm.startTime = this.value[0];
        this.searchForm.endTime = this.value[1];
      } else {
        this.searchForm.startTime = null;
        this.searchForm.endTime = null;
      }
      this.$http({
        url: '/tc/companyaccountdetail/list',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.searchForm.name,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          auditStatus: this.searchForm.auditStatus,
        },
      }).then(({ data }) => {
        this.pageIndex = 1;
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },

    // 公司充值
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },

    //审核函数，传1进来充值成功，传2充值失败
    pass(auditStatus) {
      this.dataForm.id = this.$refs.dataList.selection[0].id;
      this.$http({
        url: '/tc/companyaccountdetail/updateExamined',
        method: 'post',
        data: {
          id: this.dataForm.id,
          remarks: this.dataForm.remarks,
          realPay: this.dataForm.realPay,
          auditStatus: auditStatus,
        },
      }).then(() => {
        this.dialogAuditVisible = false;
        this.getDataList();
        this.dataForm.remarks = '';
        this.dataForm.realPay = '';
      });
    },
  },
};
</script>

<style>
.el-popper {
  width: auto;
  max-height: 500px;
  max-width: 550px;
}
</style>

<style lang="scss" scoped>
.DatepickerTime {
  width: 400px !important;
  .el-range-separator {
    width: 20px;
    font-size: 12px;
  }
}
</style>
